/* eslint-disable react/forbid-prop-types */
import 'url-search-params-polyfill';

import React from 'react';
// useState
import groupBy from 'lodash/groupBy';
// import PropTypes from 'prop-types';

import { Card, Divider, Table, Button } from 'antd';
// import moment from 'moment';
// import NumberFormat from 'react-number-format';

// import {
//   DownloadOutlined,
//   RightOutlined,
//   LeftOutlined,
// } from '@ant-design/icons';
// // import { Document, Outline, Page } from 'react-pdf';
// import fiftyStates from '../../../config/fiftyStates_copy.json';
// import providence from '../../../config/candianProvinces.json';
// import discountCodes from '../optionsJson/discountCodes.json';

const Header = block => {
  const { data, changeMenu, validation } = block;
  console.log(data);
  const getFldNameKey = validationArray => {
    const keys = {};
    validationArray.forEach((element, i) => {
      keys[element.fldName] = i;
    });
    return keys;
  };

  const validatationKeys = getFldNameKey(validation);
  console.log(validatationKeys);
  const columns = [
    {
      title: 'Range',
      dataIndex: 'pbRngNum',
      key: 'pbRngNum',
    },

    {
      title: 'Upper Quantity',
      dataIndex: 'upperQty',
      key: 'upperQty',
      editable: true,
    },
    {
      title: 'Lower Quantity',
      dataIndex: 'lowerQty',
      key: 'lowerQty',
      editable: true,
    },
    {
      title: 'Unit Price',
      dataIndex: 'unitPrc',
      key: 'unitPrc',
      editable: true,
    },
  ];

  const createItems = arr => {
    const groupped = groupBy(arr, 'nsnOrPn');
    const arrValue = Object.values(groupped);
    return arrValue.map(priceBreakArr => {
      console.log(priceBreakArr);
      return (
        <div>
          <Divider orientation="left" />
          <div className="tab-wrapper-small">
            <p>NSN/PN: {priceBreakArr[0].nsnOrPn}</p>{' '}
          </div>
          <div>
            <Table
              pagination={{
                hideOnSinglePage: true,
              }}
              bordered
              dataSource={priceBreakArr}
              columns={columns}
            />
          </div>
        </div>
      );
    });
  };

  if (!data[0]) {
    return (
      <div className="subcomponent-wrapper">
        <div className="subcomponent-header">Price Breaks</div>
        <Card>No Price Breaks Data Provided</Card>
        <Divider />
      </div>
    );
  }
  console.log(data);

  return (
    <div className="subcomponent-wrapper">
      <div className="subcomponent-header">Price Breaks</div>
      <Card>
        {createItems(data)}
        <div className="edit-button-dibbs">
          <Button
            type="primary"
            onClick={() => {
              changeMenu('pricing');
            }}
          >
            Edit
          </Button>
        </div>
      </Card>
      <Divider />
    </div>
  );
};

export default Header;



// WEBPACK FOOTER //
// ./src/pages/DibbsRfq/reviewComponents/pricebreaks.jsx